import { render, staticRenderFns } from "./QuoteMaterial.vue?vue&type=template&id=b6b3ba70&"
import script from "./QuoteMaterial.vue?vue&type=script&lang=js&"
export * from "./QuoteMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports